"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var rsRouter = {
  path: '/rs',
  component: _layout.default,
  redirect: '/rs/merchant',
  name: 'RS',
  meta: {
    title: 'RS管理',
    icon: 'el-icon-office-building'
  },
  children: [{
    path: 'merchant',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rs/merchant/index'));
      });
    },
    name: 'RSMerchantList',
    meta: {
      title: '商户管理',
      icon: 'el-icon-s-custom'
    }
  }, {
    path: 'merchant/store',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rs/merchant/store/index'));
      });
    },
    name: 'RSStoreManagement',
    meta: {
      title: '店铺管理',
      icon: 'el-icon-s-shop'
    }
  }, {
    path: 'merchant/detail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rs/merchant/detail'));
      });
    },
    name: 'RSMerchantDetail',
    meta: {
      title: '商户详情',
      icon: 'el-icon-document'
    },
    hidden: true
  }, {
    path: 'merchant/oneCardMerchant',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rs/merchant/oneCardMerchant/index'));
      });
    },
    name: 'RSOneCardMerchant',
    meta: {
      title: '一卡通商品SKU管理',
      icon: 'el-icon-goods'
    }
  }]
};
var _default = exports.default = rsRouter;